export default __webpack_public_path__ + "assets/gl-logo-77db2a3cb74c3a1b897c64e52aca44ce.png";